<p class="title">Optimize Your Bets with Auto Bet Settings</p>

<div class="h-content">
  <div class="settings-container">
    <div class="config-item" *ngFor="let config of tempConfigs; let i = index">
      <div class="config-row">
        <label class="config-label">Highest chance to win %:</label>
        <div class="config-value">{{ config.chanceToWinPercent }}%</div>
      </div>

      <div class="config-row">
        <label class="config-label">Bet Type:</label>
        <div *ngIf="config.chanceToWinPercent === 48; else callBet">
          <div class="bet-type-options">
            <label class="bet-type-option" [class.selected]="config.betTypeId === 3">
              <input
                type="radio"
                name="betType{{ i }}"
                [value]="3"
                [(ngModel)]="config.betTypeId"
                class="hidden"
                [disabled]="autoBettingIsDisable"
              />
              HIGHER
            </label>
            <label class="bet-type-option" [class.selected]="config.betTypeId === 4">
              <input
                type="radio"
                name="betType{{ i }}"
                [value]="4"
                [(ngModel)]="config.betTypeId"
                class="hidden"
                [disabled]="autoBettingIsDisable"
              />
              LOWER
            </label>
          </div>
        </div>
        <ng-template #callBet>
          <div class="call-bet-options">
            <div class="call-bet-option">CALL</div>
            <div class="call-bet-option">HIGHER</div>
            <div class="call-bet-option">LOWER</div>
          </div>
        </ng-template>
      </div>

      <div class="config-row">
        <label class="config-label">Maximum bet:</label>
        <div class="bet-controls">
          <button class="btn-primary-v3 increment-btn text-white" (click)="incrementBet(config)">
            +
          </button>
          <input
            type="number"
            [max]="100"
            [min]="0"
            class="bet-input"
            [(ngModel)]="config.maximumAllowableBet"
            (blur)="validateBetPercent(config)"
            [disabled]="autoBettingIsDisable"
            (click)="inputClick($event)"
          />
          <button class="btn-primary-v3 decrement-btn text-white" (click)="decrementBet(config)">
            -
          </button>
        </div>
      </div>
    </div>

    <div class="apply-changes">
      <button
        (click)="saveConfig()"
        class="btn-primary-v3 apply-btn text-white"
        [disabled]="autoBettingIsDisable"
      >
        APPLY CHANGES
      </button>
    </div>
  </div>
</div>
